import { StaticQuery, graphql } from 'gatsby'
import Header from './header'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

const meta = [
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, maximum-scale=1'
  },
]

const theme = {
  white: 'rgb(256, 256, 256)',
  black: 'rgb(0, 0, 0)',
  grey: 'rgb(243, 243, 243)',
  darkGrey: '#666363',
  blue: 'rgb(11, 83, 148)',
  yellow: 'rgb(255, 235, 0)',
  green: 'rgb(4, 150, 2)',
  red: 'rgb(232, 56, 38)',
  shadow: '0 0 5px 2px rgba(0,0,0,0.07)',
  seperator: '2px solid #ddd',
}

const Base = styled.div`
  background: ${props => props.theme.grey};
  min-height: 100vh;

  img {
    margin-bottom: 0;
  }
`

const Content = styled.div`
  margin 0 auto;
  max-width: 800px;
  padding: 1rem;
`

const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Layout = ({ title, children }) => (
  <StaticQuery
    query={query}
    render={data => (
      <>
        <Helmet title={title} meta={meta}>
          <html lang="en" />
        </Helmet>
        <ThemeProvider theme={theme}>
          <Base>
            <Header />
            <Content>
              {children}
            </Content>
          </Base>
        </ThemeProvider>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
